import AlternatingContent from './AlternatingContent'

export default AlternatingContent
